"use strict";
/**
 * Shared utilities for template variable substitution across the application
 *
 * Template variables use the syntax {{variablePath}} where variablePath can be:
 * - Simple identifier: {{userType}}
 * - Nested property: {{analysis.priority}}
 * - Deeply nested: {{user.profile.settings.theme}}
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VARIABLE_RESOLUTION_PRIORITY = exports.RENDER_VAR_REGEX = exports.TEMPLATE_VAR_REGEX = void 0;
/**
 * Regular expression for matching template variables in the format {{variablePath}}
 * Used for detecting and extracting template variable references in strings
 *
 * Examples:
 * - "{{userType}}" matches with capture group "userType"
 * - "{{analysis.score}}" matches with capture group "analysis.score"
 * - "Result: {{nodeId.field}}" matches with capture group "nodeId.field"
 */
exports.TEMPLATE_VAR_REGEX = /\{\{([^}]+)\}\}/g;
/**
 * Regular expression for rendering template variables in the format [[variablePath]]
 * Used in frontend rendering contexts to differentiate from backend template variables
 *
 * Note: This is distinct from {{}} syntax used in conditions and workflow parameters
 */
exports.RENDER_VAR_REGEX = /\[\[([^\]]+)\]\]/g;
/**
 * Priority order for variable resolution
 * This defines the sequence in which context sources are checked when resolving a variable path
 */
exports.VARIABLE_RESOLUTION_PRIORITY = ['nodeOutputs', 'workflowParams', 'variables'];
